export default __webpack_public_path__ + "static/media/lz-logo.7705e466.png";